/* Popup de bienvenida Charmant.
   Reglas de aparición:
   - Como mucho una vez por sesión de navegación (sessionStorage), a los 12 s,
     contados desde que la clienta acepta o rechaza las cookies (o desde que
     carga la página, si eso ya lo decidió en una visita anterior).
   - Si se cierra (X, Escape o clic fuera): no vuelve en 7 días (localStorage).
   - Si el formulario se envía con éxito: no vuelve nunca. El panel de
     confirmación solo se enseña si el envío salió de este popup; si vino de
     otro formulario de la página (pie, portada) se guarda y punto.
   - Si el envío tuvo errores, se reabre al instante para que se vean, pero
     solo cuando el fallo era suyo.
   - No aparece si el drawer del carrito está abierto (no interrumpe la compra).
   Accesibilidad: role=dialog en el marcado, foco al abrir, ciclo de Tab
   dentro del diálogo, cierre con Escape y devolución del foco al cerrar. */

(function () {
  'use strict';

  var LS_KEY = 'charmant_popup_done';
  var SS_KEY = 'charmant_popup_session';
  var WEEK_MS = 6048e5; /* 7 días */
  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  function init() {
    var popup = document.getElementById('welcomePopup');
    if (!popup) return;
    var box = popup.querySelector('.popup-box');
    var closeBtn = popup.querySelector('.popup-close');
    var previousFocus = null;

    function focusables() {
      return Array.prototype.filter.call(
        box.querySelectorAll('button, input, a[href], [tabindex]:not([tabindex="-1"])'),
        function (el) { return el.offsetParent !== null; }
      );
    }

    function show() {
      previousFocus = document.activeElement;
      popup.hidden = false;
      /* Congela la pagina de detras mientras el dialogo esta abierto: si no,
         al arrastrar dentro del popup se mueve la tienda del fondo. Es la
         misma clase que usa el carrito de Dawn. */
      document.body.classList.add('overflow-hidden');
      requestAnimationFrame(function () {
        popup.classList.add('active');
      });
      (closeBtn || box).focus();
      document.addEventListener('keydown', onKeydown);
    }

    function hide(snoozeMs) {
      if (snoozeMs) {
        try {
          /* NUNCA pisar el 'forever' de quien ya se ha suscrito.
             Sin esta comprobación pasaba lo siguiente: la clienta se suscribía,
             se guardaba 'forever' (más abajo), se le enseñaba el panel de «Ya
             eres de la familia»... y al cerrarlo con la X, con Escape o
             pinchando fuera, esta misma función escribía encima una fecha a 7
             días. Resultado: a los 7 días el popup le volvía a salir a alguien
             ya suscrita, ofreciéndole un descuento de bienvenida que ya tiene.
             Lo taimado del fallo es que si cerraba pinchando en «Ver novedades»
             sí funcionaba bien, porque se iba de la página y esto no llegaba a
             ejecutarse. Corregido el 3/08/2026. */
          if (localStorage.getItem(LS_KEY) !== 'forever') {
            localStorage.setItem(LS_KEY, String(Date.now() + snoozeMs));
          }
        } catch (e) {}
      }
      popup.classList.remove('active');
      document.body.classList.remove('overflow-hidden');
      document.removeEventListener('keydown', onKeydown);
      var finish = function () { popup.hidden = true; };
      if (reducedMotion.matches) finish();
      else setTimeout(finish, 260);
      if (previousFocus && typeof previousFocus.focus === 'function') previousFocus.focus();
    }

    function onKeydown(e) {
      if (e.key === 'Escape') {
        hide(WEEK_MS);
        return;
      }
      if (e.key === 'Tab') {
        var items = focusables();
        if (!items.length) return;
        var first = items[0];
        var last = items[items.length - 1];
        if (e.shiftKey && document.activeElement === first) {
          e.preventDefault();
          last.focus();
        } else if (!e.shiftKey && document.activeElement === last) {
          e.preventDefault();
          first.focus();
        }
      }
    }

    if (closeBtn) closeBtn.addEventListener('click', function () { hide(WEEK_MS); });
    popup.addEventListener('click', function (e) {
      if (!box.contains(e.target)) hide(WEEK_MS);
    });

    /* ¿El envío salió de ESTE popup? Liquid pone form.posted_successfully?
       a true en TODOS los {% form 'customer' %} de la página (pie, portada),
       así que hay que marcarlo desde el propio formulario del popup. */
    var OWN_KEY = 'charmant_popup_sent';
    var ownForm = popup.closest ? popup.closest('form') : null;
    if (ownForm) {
      ownForm.addEventListener('submit', function () {
        try { sessionStorage.setItem(OWN_KEY, '1'); } catch (e) {}
      });
    }
    var ownSubmit = false;
    try {
      ownSubmit = sessionStorage.getItem(OWN_KEY) === '1';
      sessionStorage.removeItem(OWN_KEY);
    } catch (e) {}

    var stored = null;
    try { stored = localStorage.getItem(LS_KEY); } catch (e) {}

    /* Envío con éxito, venga del popup o de otro formulario de suscripción
       de la página: ya está suscrita, no volver a molestar. Pero solo se
       le enseña el panel de confirmación si el envío salió de aquí. */
    if (popup.dataset.posted === 'true') {
      var yaHecho = stored === 'forever';
      if (!yaHecho) {
        try { localStorage.setItem(LS_KEY, 'forever'); } catch (e) {}
      }
      if (ownSubmit && !yaHecho) show();
      return;
    }

    /* Envío con errores: reabrir solo si el fallo fue de este popup. */
    if (popup.dataset.errors === 'true') {
      if (ownSubmit) {
        show();
        return;
      }
      /* El error venía de otro formulario: quitar el aviso que Liquid ya
         ha pintado dentro del popup, para que no aparezca más tarde. */
      var aviso = popup.querySelector('.popup-message--error');
      if (aviso && aviso.parentNode) aviso.parentNode.removeChild(aviso);
    }

    if (stored === 'forever') return;
    if (stored && Date.now() < parseInt(stored, 10)) return;
    if (stored) {
      try { localStorage.removeItem(LS_KEY); } catch (e) {}
    }
    try { if (sessionStorage.getItem(SS_KEY)) return; } catch (e) {}

    function armarCuentaAtras() {
      setTimeout(function () {
        var cartOpen = document.querySelector('cart-drawer.active, cart-drawer.animate');
        if (cartOpen) return; /* se intentará en la siguiente página */
        try { sessionStorage.setItem(SS_KEY, '1'); } catch (e) {}
        show();
      }, 12000);
    }

    /* Los 12 segundos no arrancan hasta que ella haya resuelto lo de las
       cookies. El aviso de cookies es una tarjeta centrada que NO se quita
       sola: si el popup contase desde que carga la página, le saldría encima
       y se le juntarían las dos ventanas.

       Si ya hay decisión guardada —visitas siguientes, que son la mayoría— la
       tarjeta no llega a aparecer y se cuenta desde la carga, como toda la
       vida. Si localStorage da error, cookie-banner.js tampoco puede leerlo y
       enseña la tarjeta igualmente, así que ahí también toca esperar. */
    var cookieBanner = document.getElementById('cookieBanner');
    var esperandoCookies = false;
    if (cookieBanner) {
      try {
        esperandoCookies = !localStorage.getItem('charmant_cookie_consent');
      } catch (e) {
        esperandoCookies = true;
      }
    }

    if (esperandoCookies) {
      document.addEventListener('charmant:cookie-consent', armarCuentaAtras, { once: true });
    } else {
      armarCuentaAtras();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
